// User-related constants
export const USER_CACHE_KEY = "evoorion-user-data";
export const USER_CACHE_TIMESTAMP_KEY = "evoorion-user-cache-timestamp";
export const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours
export const DEFAULT_REFETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes
export const HYDRATION_DELAY = 100; // ms
